import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CompanyMentorModel } from 'common/models/page-models/internship-company/company-mentor/company-mentor-data.model';
import { CompanyMentorMetaModel } from 'common/models/page-models/internship-company/company-mentor/company-mentor-form-meta.model';
import { CompanyMentorListingModel } from 'common/models/page-models/internship-company/company-mentor/company-mentor-grid.model';
import { WidgetModel } from 'common/models/utility-models/base-model';
import { GridWidgetModel } from 'common/models/utility-models/list-utility.model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { CompanyMentorGridWidgetService } from 'common/widget/internship-company/internship-company-mentor-grid-widget.service';


@Injectable({
    providedIn: 'root'
})
export class CompanyMentorGridResolver extends GridResolver<CompanyMentorModel, CompanyMentorListingModel> {
    constructor(
        protected fs: CompanyMentorGridWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }


    

    override initWidget(envelopeType: any, transferData: any): WidgetModel {
        const widget = new GridWidgetModel();
        const metaModel = this.pageService.getMetaModel();
        widget.recordPerPage = metaModel.properties?.recordPerPage;
        widget.searchableFeilds = metaModel.properties?.searchableFields;
        transferData.formData = new CompanyMentorModel();
        transferData.formMeta = new CompanyMentorMetaModel().getMetaModel();
        widget.transferData = transferData;
        return widget;
    }

}
